module.exports = require("react-collapse");


//////////////////
// WEBPACK FOOTER
// external "react-collapse"
// module id = 257
// module chunks = 0